// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.security-update-modal__overlay {
  position: fixed;
  inset: 0;
  z-index: 10001;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.security-update-modal__card {
  width: min(520px, 100%);
  background: white;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.28);
  font-family: 'Roboto', sans-serif;
  overflow: hidden;
  animation: securityModalAppear 0.18s ease-out;
}

@keyframes securityModalAppear {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(-8px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.security-update-modal__card::before {
  content: '';
  display: block;
  height: 6px;
  background: linear-gradient(
    90deg,
    #000000 0%,
    #4a4a4a 50%,
    #de4858 100%
  );
}

.security-update-modal__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 24px 8px 24px;
}

.security-update-modal__title {
  margin: 0;
  flex: 1;
  font-size: 20px;
  font-weight: 700;
  color: rgba(74, 74, 74, 1);
  font-family: 'Roboto', sans-serif;
}

.security-update-modal__badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.security-update-modal__badge--critical {
  background: var(--netsfere-red, #de4858);
  color: #ffffff;
}

.security-update-modal__badge--recommended {
  background: #f4a300;
  color: #ffffff;
}

.security-update-modal__body {
  margin: 0;
  padding: 8px 24px 12px 24px;
  font-size: 15px;
  line-height: 1.45;
  color: rgba(74, 74, 74, 1);
}

.security-update-modal__countdown {
  display: block;
  padding: 4px 24px 16px 24px;
  font-weight: 600;
  font-size: 14px;
  color: rgba(74, 74, 74, 0.85);
}

.security-update-modal__actions {
  display: flex;
  flex-direction: row-reverse;
  gap: 12px;
  padding: 8px 24px 24px 24px;
}

.security-update-modal__button {
  flex: 1;
  height: 44px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
  transition: filter 0.15s ease-in-out, background-color 0.15s ease-in-out;
}

.security-update-modal__button:focus-visible {
  outline: 2px solid rgba(222, 72, 88, 0.6);
  outline-offset: 2px;
}

.security-update-modal__button--primary {
  background-color: var(--netsfere-red, #de4858);
  color: #ffffff;
}

.security-update-modal__button--primary:hover {
  filter: brightness(1.05);
}

.security-update-modal__button--secondary {
  background-color: transparent;
  color: rgba(74, 74, 74, 1);
  border: 1.5px solid rgba(74, 74, 74, 0.4);
}

.security-update-modal__button--secondary:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

@media (max-width: 480px) {
  .security-update-modal__actions {
    flex-direction: column-reverse;
  }
  .security-update-modal__button {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .security-update-modal__card {
    animation: none;
  }
  .security-update-modal__button {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SecurityUpdate/SecurityUpdateModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;EACjC,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX;;;;;GAKC;AACH;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,wEAAwE;AAC1E;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".security-update-modal__overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10001;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.security-update-modal__card {\n  width: min(520px, 100%);\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.28);\n  font-family: 'Roboto', sans-serif;\n  overflow: hidden;\n  animation: securityModalAppear 0.18s ease-out;\n}\n\n@keyframes securityModalAppear {\n  from {\n    opacity: 0;\n    transform: scale(0.96) translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.security-update-modal__card::before {\n  content: '';\n  display: block;\n  height: 6px;\n  background: linear-gradient(\n    90deg,\n    #000000 0%,\n    #4a4a4a 50%,\n    #de4858 100%\n  );\n}\n\n.security-update-modal__header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 24px 24px 8px 24px;\n}\n\n.security-update-modal__title {\n  margin: 0;\n  flex: 1;\n  font-size: 20px;\n  font-weight: 700;\n  color: rgba(74, 74, 74, 1);\n  font-family: 'Roboto', sans-serif;\n}\n\n.security-update-modal__badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.security-update-modal__badge--critical {\n  background: var(--netsfere-red, #de4858);\n  color: #ffffff;\n}\n\n.security-update-modal__badge--recommended {\n  background: #f4a300;\n  color: #ffffff;\n}\n\n.security-update-modal__body {\n  margin: 0;\n  padding: 8px 24px 12px 24px;\n  font-size: 15px;\n  line-height: 1.45;\n  color: rgba(74, 74, 74, 1);\n}\n\n.security-update-modal__countdown {\n  display: block;\n  padding: 4px 24px 16px 24px;\n  font-weight: 600;\n  font-size: 14px;\n  color: rgba(74, 74, 74, 0.85);\n}\n\n.security-update-modal__actions {\n  display: flex;\n  flex-direction: row-reverse;\n  gap: 12px;\n  padding: 8px 24px 24px 24px;\n}\n\n.security-update-modal__button {\n  flex: 1;\n  height: 44px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 600;\n  font-family: 'Roboto', sans-serif;\n  transition: filter 0.15s ease-in-out, background-color 0.15s ease-in-out;\n}\n\n.security-update-modal__button:focus-visible {\n  outline: 2px solid rgba(222, 72, 88, 0.6);\n  outline-offset: 2px;\n}\n\n.security-update-modal__button--primary {\n  background-color: var(--netsfere-red, #de4858);\n  color: #ffffff;\n}\n\n.security-update-modal__button--primary:hover {\n  filter: brightness(1.05);\n}\n\n.security-update-modal__button--secondary {\n  background-color: transparent;\n  color: rgba(74, 74, 74, 1);\n  border: 1.5px solid rgba(74, 74, 74, 0.4);\n}\n\n.security-update-modal__button--secondary:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n@media (max-width: 480px) {\n  .security-update-modal__actions {\n    flex-direction: column-reverse;\n  }\n  .security-update-modal__button {\n    width: 100%;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .security-update-modal__card {\n    animation: none;\n  }\n  .security-update-modal__button {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
